import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import * as FiIcons from 'react-icons/fi';

const TYPE_ICONS = {
  delegation: FiIcons.FiGitMerge,
  approval: FiIcons.FiCheckSquare,
  error: FiIcons.FiAlertTriangle,
  success: FiIcons.FiCheck,
  cron: FiIcons.FiClock,
  agent: FiIcons.FiCpu,
  system: FiIcons.FiActivity
};

const STATUS_TONES = {
  error: 'var(--status-failed)',
  failed: 'var(--status-failed)',
  success: 'var(--status-running)',
  running: 'var(--status-running)',
  active: 'var(--status-running)',
  autonomous: 'var(--status-autonomous)'
};

function resolveTimestamp(event) {
  if (event.timestamp instanceof Date) return event.timestamp;
  if (typeof event.timestamp === 'number') return new Date(event.timestamp);
  if (typeof event.at === 'number') return new Date(event.at);
  if (typeof event.createdAt === 'number') return new Date(event.createdAt);
  return null;
}

/**
 * Single live-activity row (T2a): type glyph, actor + message, and a
 * date-fns relative timestamp when a Date-ish field exists (mock events
 * carry pre-formatted strings like "2m" — those pass through verbatim).
 */
function EventFeedItem({ event }) {
  const Icon = TYPE_ICONS[event.type] || TYPE_ICONS.system;
  const timestamp = resolveTimestamp(event);
  const tone = STATUS_TONES[event.status] || 'var(--text-secondary-ops)';

  return (
    <div className="event-item">
      <span className="event-item-icon" style={{ color: tone }}>
        <Icon size={13} />
      </span>
      <div className="event-item-body">
        <strong>{event.agent}</strong>
        <p>{event.message || event.text}</p>
      </div>
      <time>
        {timestamp
          ? formatDistanceToNow(timestamp, { addSuffix: true })
          : event.time || event.at || ''}
      </time>
    </div>
  );
}

export default EventFeedItem;
